import request from '@/request'

export function uploadFile (data) {
  return request({
    url: '/gs-enterprise-admin/gs/file/upload',
    method: 'post',
    header: {
      'Content-type': 'multipart/form-data'
    },
    data
  })
}

export function shareFileDetail (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/share/' + params.shorturl,
    method: 'get',
    params
  })
}

export function shortFileDetail (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/short/' + params.shorturl,
    method: 'get',
    params
  })
}

export function getFilePreview (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/onlinePreview',
    method: 'get',
    params
  })
}

export function getAllSignRecord (id) {
  return request({
    url: '/gs-enterprise-admin/gs/file/sign/record/all/' + id,
    method: 'get'
  })
}

export function getAllAutograph () {
  return request({
    url: '/gs-enterprise-admin/gs/autograph/all',
    method: 'get'
  })
}

export function getAutoDate () {
  return request({
    url: '/gs-enterprise-admin/gs/autograph/getDate',
    method: 'get'
  })
}

export function signatureAllList (params) {
  return request({
    url: '/gs-enterprise-admin/gs/signature/signatureList',
    method: 'get',
    params
  })
}

export function checkStatus (fileId) {
  return request({
    url: '/gs-enterprise-admin/gs/file/checkStatus/' + fileId,
    method: 'get'
  })
}

export function shorturlDetail (params) {
  return request({
    url: '/gs-enterprise-admin/gs/signature/all',
    method: 'get',
    params
  })
}

export function getShareCode (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/getShareCode',
    method: 'get',
    params
  })
}

export function queryVersion () {
  return request({
    url: '/gs-enterprise-admin/umsMember/keystore/version',
    method: 'get'
  })
}

export function getKeyStore () {
  return request({
    url: '/gs-enterprise-admin/umsMember/keystore',
    method: 'get'
  })
}

export function fileDraft (data) {
  return request({
    url: '/gs-enterprise-admin/gs/file/draft',
    method: 'post',
    data
  })
}

export function changeFileType (fileId, data) {
  return request({
    url: '/gs-enterprise-admin/gs/file/' + fileId + '/type',
    method: 'put',
    data
  })
}

export function saveInFile (data) {
  return request({
    url: '/gs-enterprise-admin/gs/file/file/save',
    method: 'post',
    data
  })
}

export function chainPayload (data) {
  return request({
    url: '/gs-enterprise-admin/chain/payload',
    method: 'post',
    data
  })
}

export function fileHashQuery (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/hash/query',
    method: 'get',
    params
  })
}

export function getFileDetail (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/' + params.id,
    method: 'get',
    params
  })
}

export function schemeUrl (data) {
  return request({
    url: '/gs-enterprise-admin/wx/getScheme',
    method: 'get',
    data
  })
}

// 根据hash和类型查询状态(-1不存在或失效，0有效，>0其他为失效时间)
export function queryStatusByHash (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/hash/queryStatusByHash',
    method: 'get',
    params
  })
}

export function chainSimpleQuery (data) {
  return request({
    url: '/gs-enterprise-admin/chain/simple/query',
    method: 'post',
    data
  })
}

export function getMyFile (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/myFile',
    method: 'get',
    params
  })
}

export function getstatistics (params) {
  return request({
    url: '/gs-enterprise-admin/gs/file/statistics',
    method: 'get',
    params
  })
}
